<template>
  <div>
    <el-dialog v-dialog-drag :title="title" :visible.sync="showDialog" :fullscreen=true  :destroy-on-close="true" :append-to-body=true  :before-close="cancel">
      <div style="margin-bottom: 20px;margin-top: 30px">
        <el-button size="small" type="success" icon="el-icon-upload" @click="exportTo()">确认选择</el-button>
      </div>
      <div style="width:100%;">
        <w-table :columns="column" :table-data="tableData" @rowSelection="rowSelection"
                 @getTableSearchSortCon="getTableSearchSortCon" :isPagination="true"
                 ref="wMyTable" :page="page" @pageChange="handlePagePagination" :isShowRowSelection="true">
          <div slot="operation" slot-scope="{record}">
            <el-button size="small" type="success" icon="el-icon-upload" @click="exportTo(record)">确认选择</el-button>
          </div>
          <div slot="mailFlag" slot-scope="{text,record}">
            <el-tag v-if="text === 'NOT_APPLYING'" type="primary" >未申请</el-tag>
            <el-tag v-else-if="text === 'SUBMITTED' && record.mailAuditFlag" type="warning" style="background-color: #FFFFFF">待邮寄</el-tag>
            <el-tag v-else-if="text === 'SUBMITTED' && !record.mailAuditFlag" type="warning">待审核</el-tag>
            <el-tag v-else-if="text === 'MAILED'" type="success">已邮寄</el-tag>
            <span v-else-if="text === 'CANCELED'" style="display: flex;align-items: center">
                  <el-tag type="danger">
                    <span >已取消</span>
                  </el-tag>
                  <w-ellipsis-and-look style="margin-left:5px" class="w-ellipsis-and-look" :text="record.rejectionReason"
                                       :column="{title:'驳回原因'}" :onlyDetail="true"
                                       :isOpenHtml="false">
                  </w-ellipsis-and-look>
            </span>
            <el-tag v-else type="info">未知状态</el-tag>
          </div>
          <div slot="mailNumbers" slot-scope="{text,record,index}">
            <ex-fold-form :scope="{time:text, index,type:'mail'}"></ex-fold-form>
          </div>
          <div slot="mailingContent" slot-scope="{text,record,index}" v-if="text">
            <ex-fold-table :scope="{time, record:record.mailingContent, index}"></ex-fold-table>
          </div>
          <div slot="contractNumbers" slot-scope="{text,record,index}">
            <ex-fold-table-cell v-if="text" :scope="{text, record, index}"></ex-fold-table-cell>
          </div>
          <div slot="filterStatus" slot-scope="{ setSelectedKeys, selectedKeys, confirm, column,clearFilters  }"
               style="padding: 8px; position: relative; z-index: 9999 !important;">
            <div style="padding: 15px 15px 0">
              <el-radio-group v-model="selectedKeys[0]">
                <el-row :gutter="20">
                  <el-col :span="12">
                    <el-radio label='未申请'>未申请</el-radio>
                  </el-col>
                  <el-col :span="12">
                    <el-radio label='已提交'>已提交</el-radio>
                  </el-col>
                </el-row>
                <el-row :gutter="20">
                  <el-col :span="12">
                    <el-radio label='已邮寄'>已邮寄</el-radio>
                  </el-col>
                  <el-col :span="12">
                    <el-radio label='已取消'>已取消</el-radio>
                  </el-col>
                </el-row>
              </el-radio-group>
            </div>
            <div style="display: flex;padding: 15px">
              <a-button
                  type="primary"
                  icon="search"
                  size="small"
                  style="width: 90px; margin-right: 8px"
                  @click="() => handleSearch(setSelectedKeys,selectedKeys, confirm, column,clearFilters)">搜索
              </a-button>
              <a-button size="small" style="width: 90px" @click="() => handleReset( column,clearFilters)">取消
              </a-button>
            </div>
          </div>
        </w-table>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import TableHeadNote from "@/components/customerTable/TableHeadNote.vue";
import {tableOperationMixin} from "@/mixins/tableOperation";
import ExFoldCell from "@/components/ExFoldCell.vue";
import ExFoldTable from "@/components/ExFoldTable.vue";
import {mail} from "@/utils/data/tableCol/mail/mail";
import {getMailPage} from "@/api/dilivery/mail";
import ExFoldForm from "@/components/ExFoldForm.vue";
import ExFoldTableCell from "@/components/ExFoldTableCell.vue";


export default {
  name: "SelectMail",
  components: {ExFoldForm, ExFoldTable,ExFoldTableCell, ExFoldCell, TableHeadNote},
  mixins: [tableOperationMixin],
  props:['showDialog'],
  data() {
    return {
      time:[
        {name:'合同份数',time:'numberOfContract'},
        {name:'是否扫描合同',time:'contractScanningFlag'},
        {name:'发票份数',time:'numberOfInvoice'},
        {name:'是否邮寄报账资料',time:'reimbursementFileFlag'},
        {name:'是否扫描报账资料',time:'reimbursementScanningFlag'},
        {name:'报账说明',time:'reimbursementExplain'},
        {name:'单独邮件文件说明',time:'singleMailFileExplain'},
        {name:'结题报告份数',time:'numberOfReport'},
        {name:'是否扫描结题报告',time:'reportScanningFlag'},
        {name:'营业执照份数',time:'numberOfLicense'},
      ],
      title: '选择邮寄信息（日期提醒）',
      selectedRows: [],
      searchConditionTag: [],//搜索tag
      sortConditionTag: [],
      tableData: [],
      page: {
        pageSize: 10,
        currentNum: 1,
        total: null
      }
    }
  },
  computed: {
    column() {
      let cols = mail(this.searchConditionTag || {});
      return JSON.parse(JSON.stringify(cols))
    },
  },
  mounted() {
    this.getData()
  },
  methods: {
    //已提交表格选择框
    rowSelection(selectedRows) {
      this.selectedRows = selectedRows.map(item=>item.id)
    },
    getTableSearchSortCon(searchConditionTag, sortConditionTag) {
      this.searchConditionTag = searchConditionTag
      this.sortConditionTag = sortConditionTag
      this.getData('search')
    },
    // 获取发票表数据
    getData(type) {
      let params = {
        'page.current': this.page.currentNum,
        'page.size': this.page.pageSize,
      }
      if (type) {
        params['page.current'] = 1
        params['page.size'] = 10
      }
      this.sortConditionTag.forEach(item => {
        params["order"] = item.colName + "." + item.order
      })
      let sendData = {
        "query#mailFlag.EQ":"SUBMITTED"
      }
      sendData = this.getSearch(sendData)
      getMailPage(params, sendData).then(res => {
        if (res.code === 200) {
          this.tableData = res.data.records
          this.page.currentNum = parseInt(res.data.current)
          this.page.pageSize = parseInt(res.data.size)
          this.page.total = parseInt(res.data.total)
        }
      }).catch(() => {
      })
    },
    getSearch(sendData) {
      this.searchConditionTag.forEach(item => {
        let value=item.value
        if (item.key==='mailFlag') {
          if (value === '未申请'){
            value='NOT_APPLYING'
          }else if(value==='已提交'){
            value='SUBMITTED'
          }else if (value==='已邮寄'){
            value='MAILED'
          }else {
            value='CANCELED'
          }
        }
        sendData["query#" + item.key + ".LIKE"] = value
      })
      return sendData
    },
    //页码的变动
    handlePagePagination(page) {
      this.page.currentNum = page.currentNum
      this.page.pageSize = page.pageSize
      this.getData()
    },
    cancel(){
      this.$emit('mail',[])
    },
    exportTo(row){
      let selectedRows = []
      if (row && row.id) {
        selectedRows.push(row.id)
        this.$emit('mail',selectedRows)
      } else {
        if (this.selectedRows.length > 0) {
          selectedRows = this.selectedRows
          if(this.selectedRows.length > 1){
            this.$messageUi.error('仅能选择一条邮寄信息')
          }else{
            this.$emit('mail',selectedRows)
          }
        } else {
          this.$messageUi.error('请选择邮寄信息')
        }
      }
    }
  }
}
</script>

<style scoped>
.status-tag-container {
  display: flex;
  justify-content: center; /* 水平居中 */
  align-items: center; /* 垂直居中，如果需要 */
  height: 100%; /* 确保标签在单元格中垂直居中 */
}

</style>
